<template>
  <div id="contenedor-exportar-excel-observaciones-auditorias">
    <template v-if="listItem">
      <v-list-item @click="generarExcelObservacionesAuditorias" link>
        <v-list-item-icon class="mx-2">
          <v-icon> mdi-file-excel </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title> Exportar Observaciones </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <template v-else>
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn text rounded v-bind="attrs" v-on="on" @click="generarExcelObservacionesAuditorias">
            <v-icon left> mdi-file-excel </v-icon>
            Exportar
          </v-btn>
        </template>
        <span> Exportar Observaciones </span>
      </v-tooltip>
    </template>
  </div>
</template>

<script>
// import AUDITORIAS_EXCEL from '@/graphql/querys/administracion/auditorias/auditoriasExcel.gql';
import mixGenerarExcel from '@/helpers/mixGenerarExcel';

// Fila en la que inician los datos con titulos del excel
const filaTitulos = 2;
// const filaSubtitulos = filaTitulos + 1;
const filaInicioDatos = filaTitulos + 1;

export default {
  name: 'ExcelObservacionesAuditorias',
  mixins: [mixGenerarExcel],
  props: {
    listItem: {
      type: Boolean,
      required: false,
      default: false,
    },
    auditorias: {
      type: Array,
      required: true,
    },
  },
  // apollo: {
  //   auditorias: {
  //     query: AUDITORIAS_EXCEL,
  //   },
  // },
  data() {
    return {
      formularioValido: false,
      estaCargando: false,
      nombreDocumento: 'OBSERVACIONES DE AUDITORIAS',
      configuracionExcel: {},
      // Estilo del header
      estiloHeader: {
        font: {
          bold: true,
        },
        alignment: {
          horizontal: 'center',
          vertical: 'center',
          wrapText: true,
        },
      },
      headersColumnas: [
        {
          value: 'FECHA VENCIMIENTO',
          nombreColumna: 'fechaVencimiento',
          orden: 0,
        },
        {
          value: 'ENTE',
          nombreColumna: 'ente',
          orden: 1,
        },
        {
          value: 'EJERCICIO',
          nombreColumna: 'ejercicio',
          orden: 2,
        },
        {
          value: 'AUDITORIA',
          nombreColumna: 'auditoria',
          orden: 3,
        },
        {
          value: 'INFORME',
          nombreColumna: 'informe',
          orden: 4,
        },
        {
          value: 'NUM. OBSERV.',
          nombreColumna: 'numeroObservacion',
          orden: 5,
        },
        {
          value: 'OBSERVACIÓN',
          nombreColumna: 'observacion',
          orden: 6,
        },
        {
          value: 'MONTO ORIGINAL',
          nombreColumna: 'montoOriginal',
          orden: 7,
        },
        {
          value: 'MONTO PENDIENTE',
          nombreColumna: 'montoPendiente',
          orden: 8,
        },
        {
          value: 'ESTATUS',
          nombreColumna: 'estatus',
          orden: 9,
        },
        {
          value: 'COMENTARIO ESTATUS',
          nombreColumna: 'comentarioEstatus',
          orden: 10,
        },
        {
          value: 'FECHA',
          nombreColumna: 'fecha',
          orden: 11,
        },
        {
          value: 'CONTRATO',
          nombreColumna: 'contrato',
          orden: 12,
        },
        {
          value: 'RESIDENTE',
          nombreColumna: 'residente',
          orden: 13,
        },
        {
          value: 'CONTRATISTA',
          nombreColumna: 'contratista',
          orden: 14,
        },
        {
          value: 'DESGLOSE',
          nombreColumna: 'desglose',
          orden: 15,
        },
      ],
      noData: [
        {
          fechaVencimiento: '',
          ente: '',
          ejercicio: '',
          auditoria: '',
          informe: '',
          numeroObservacion: '',
          observacion: '',
          montoOriginal: '',
          montoPendiente: '',
          estatus: '',
          comentarioEstatus: '',
          fecha: '',
          contrato: '',
          residente: '',
          contratista: '',
          desglose: '',
        },
      ],
      estilos: {
        centrado: {
          alignment: {
            horizontal: 'center',
            vertical: 'center',
          },
        },
        dinero: {
          numberFormat: '$#,##0.00',
        },
      },
    };
  },
  methods: {
    async generarExcelObservacionesAuditorias() {
      const data = await this.crearExcelObservacionesAuditorias;
      await this.mixGenerarExcel(data);
    },
    getResidente(contrato) {
      if (!contrato) return '';
      const responsable = contrato.responsables.find(
        (contratoResponsable) => contratoResponsable.principal,
      );
      if (!responsable) return '';
      return responsable.funcionario.nombre;
    },
  },
  computed: {
    getAuditorias() {
      if (!this.auditorias) return [];
      return this.auditorias;
    },
    getHeaders() {
      const headers = this.headersColumnas
        .map((header) => header.value)
        .sort((a, b) => a.orden - b.orden);
      return headers;
    },
    getColumnas() {
      const columnas = this.headersColumnas
        .map((columna) => columna.nombreColumna)
        .sort((a, b) => a.orden - b.orden);
      return columnas;
    },
    getObservacionesAuditorias() {
      const observacionesAuditorias = [];
      this.getAuditorias.forEach((auditoria) => {
        if (auditoria.informes.length > 0) {
          auditoria.informes
            .sort((a, b) => new Date(a.fechaVencimiento) - new Date(b.fechaVencimiento))
            .forEach((informe) => {
              if (informe.observaciones.length > 0) {
                informe.observaciones.forEach((observacion) => {
                  observacionesAuditorias.push({
                    fechaVencimiento: this.$moment(informe.fechaVencimiento).format('DD/MM/YYYY'),
                    ente: auditoria.enteFiscalizador.descripcion,
                    ejercicio: auditoria.ejercicio,
                    auditoria: auditoria.nombre,
                    informe: informe.nombre,
                    numeroObservacion: observacion.numero,
                    observacion: observacion.descripcion,
                    montoOriginal: {
                      value: observacion.montoOriginal,
                      estilo: {
                        ...this.estilos.dinero,
                      },
                    },
                    montoPendiente: {
                      value: observacion.montoPendiente,
                      estilo: {
                        ...this.estilos.dinero,
                      },
                    },
                    estatus: observacion.estatus,
                    comentarioEstatus: observacion.comentarios,
                    fecha: observacion.fechaEstatus,
                    contrato: observacion.contrato?.numero,
                    residente: this.getResidente(observacion.contrato),
                    contratista: observacion.contrato?.contratista.nombreRazonSocial,
                    desglose: '',
                  });
                });
              }
            });
        }
      });
      return observacionesAuditorias;
    },
    crearDatosDocumento() {
      const datosDocumento = [];
      datosDocumento.push({
        value: `DESGLOSE DE OBSERVACIONES DE AUDITORIA AL ${new Date()
          .toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' })
          .toUpperCase()}`,
        row: 1,
        col: 1,
        estilo: {
          font: {
            size: 14,
            bold: true,
          },
          alignment: {
            horizontal: 'left',
            vertical: 'center',
          },
        },
        combinar: {
          row: 1,
          col: 27,
        },
      });
      return datosDocumento;
    },
    crearExcelObservacionesAuditorias() {
      const datosDocumento = this.crearDatosDocumento;
      const dataHeaders = this.getHeaders;
      const nombreDeColumnas = this.getColumnas;
      const bodyData = this.getObservacionesAuditorias.length > 0
        ? this.getObservacionesAuditorias
        : this.noData;
      const data = {
        excelData: {
          configuration: this.configuracionExcel,
          header: {
            filaInicio: filaTitulos,
            estilo: this.estiloHeader,
            datosDocumento: [...datosDocumento],
            data: [...dataHeaders],
          },
          body: {
            nombreDeColumnas,
            filaInicio: filaInicioDatos,
            data: bodyData,
          },
        },
      };
      return data;
    },
  },
};
</script>

<style lang="scss" scoped></style>
